/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  ImportProductsMutationRequest,
  ImportProductsMutationResponse,
} from "../types/ImportProducts.ts"

export const importProductsMutationKey = () =>
  [{ url: "/v1/product/import-products" }] as const

export type ImportProductsMutationKey = ReturnType<
  typeof importProductsMutationKey
>

/**
 * @summary Import products
 * {@link /v1/product/import-products}
 */
export async function importProducts(
  data: ImportProductsMutationRequest,
  config: Partial<RequestConfig<ImportProductsMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ImportProductsMutationResponse,
    ResponseErrorConfig<Error>,
    ImportProductsMutationRequest
  >({
    method: "POST",
    url: `/v1/product/import-products`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function importProductsMutationOptions(
  config: Partial<RequestConfig<ImportProductsMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = importProductsMutationKey()
  return mutationOptions<
    ResponseConfig<ImportProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportProductsMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return importProducts(data, config)
    },
  })
}

/**
 * @summary Import products
 * {@link /v1/product/import-products}
 */
export function useImportProducts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ImportProductsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: ImportProductsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ImportProductsMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? importProductsMutationKey()

  const baseOptions = importProductsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ImportProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportProductsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ImportProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportProductsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ImportProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportProductsMutationRequest },
    TContext
  >
}
